
import Translatable from '@/components/translatable_text/Translatable'
import { useState } from 'react'

import api from '@/context/apiRequest';
import { toast } from 'sonner'
import { AxiosError } from 'axios'
import { AppState, useSelector } from '@/store/Store'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import MsgComponent from '@/components/msg_component/MsgComponent';
import ButtonComponent from '@/components/button/ButtonComponent';
import { useAutoCleanError } from '@/hooks/useAutoCleanError';


type DeleteProps = {
  preview: string,
  setOpen: (value: boolean) => void,
  url: string,
  invalidate?: string,
  disabled?: boolean,
}

export default function DeleteElComponent({ preview, setOpen, url, invalidate, disabled }: DeleteProps){

  const customizer = useSelector((state: AppState) => state.customizer);
  const [ err, setErr ] = useState<string>()
  const [ isSubmitting, setIsSubmitting ] = useState<boolean>(false)

  const queryClient = useQueryClient();
  const deleteMutation = useMutation({
    mutationFn: () => {
      return api().delete(url)
    }, 
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [invalidate]})
    }
  })

  const handleDelete = async () => {
    
    try {
      setIsSubmitting(true);
      const res = await deleteMutation.mutateAsync();
      console.log(res);
      toast.success('Deleted successfully')
      setIsSubmitting(false);
      setOpen(false);

    } catch (error) {
      if (error instanceof AxiosError) {
        setErr(error.response?.data?.message || error.response?.data.error)
      }
      console.log(error)
      setIsSubmitting(false);

    } 
  } 

  useAutoCleanError(err, setErr)

  return (
    <div dir={customizer.activeDir} className='w-full px-6'>
      <div className='flex flex-col gap-2 p-4'>
        <span>
          <Translatable>
            Deleting this will result in deleting all the data and information related to it and can not be retained when proceeded
          </Translatable>
        </span>
        <div className='w-full flex items-center justify-center'>
          <span className='text-gray-500'>
            {preview}
          </span>
        </div>
      </div>

      <MsgComponent className='flex items-center justify-center text-rose-700 p-4' message={err}/>
      <ButtonComponent
        title='Delete'
        className='w-full mt-10 bg-purple hover:bg-rose-900'
        isSubmitting={isSubmitting}
        onClick={handleDelete}
        disabled={disabled}
      />
    </div>
  )
}